import { render, staticRenderFns } from "./space-before-prep-edit.vue?vue&type=template&id=6830c789&scoped=true"
import script from "./space-before-prep-edit.vue?vue&type=script&lang=js"
export * from "./space-before-prep-edit.vue?vue&type=script&lang=js"
import style0 from "./space-before-prep-edit.vue?vue&type=style&index=0&id=6830c789&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6830c789",
  null
  
)

export default component.exports